import React, { useEffect } from "react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useDispatch } from "react-redux";
import { updateUser } from "../../redux/slices/userSlice";
import CtaButton from "../Buttons/CtaButton/CtaButton";
import GradientButton from "../Buttons/GradientButton/GradientButton";

export const CustomConnectButton = () => {
  const dispatch = useDispatch();


  useEffect(() => {
    const intervalId = setInterval(() => {
      const metaMaskButton = document.querySelector('[data-testid="rk-wallet-option-metaMask"]');
      const trustWalletButton = document.querySelector('[data-testid="rk-wallet-option-trust"]');
      const coinbaseWalletButton = document.querySelector('[data-testid="rk-wallet-option-coinbase"]');
      const walletConnectButton = document.querySelector('[data-testid="rk-wallet-option-walletConnect"]');
      [metaMaskButton, trustWalletButton, coinbaseWalletButton, walletConnectButton].forEach((button, index) => {
        if (button && !button.hasAttribute('listener-added')) {
          button.setAttribute('listener-added', 'true');
          button.addEventListener('click', (event) => {
            event.preventDefault();
            if (window.innerWidth < 768) {
              const urls = [
                'https://metamask.app.link/dapp/https://golden-years-website.vercel.app/',
                'https://link.trustwallet.com/open_url?coin_id=60&url=https://golden-years-website.vercel.app/',
                'https://go.cb-w.com/dapp?cb_url=https://golden-years-website.vercel.app/',
                "https://mywallet.com/wc?uri=https://golden-years-website.vercel.app/",
              ];
              window.location.href = urls[index];
            }
          });
        }
      });
      if ([metaMaskButton, walletConnectButton, coinbaseWalletButton, trustWalletButton].every(button => button && button.hasAttribute('listener-added'))) {
        clearInterval(intervalId);
      }
    }, 1000); 
    return () => clearInterval(intervalId);
  }, []);


  return (
    <ConnectButton.Custom>
      {({
        account,
        chain,
        openAccountModal,
        openChainModal,
        openConnectModal,
        authenticationStatus,
        mounted,
      }) => {
        const ready = mounted && authenticationStatus !== "loading";
        const connected =
          ready &&
          account &&
          chain &&
          (!authenticationStatus || authenticationStatus === "authenticated");

        const walletAddress = account?.address || "";

        dispatch(updateUser({ walletAddress }));
        

        return (
          <div
            {...(!ready && {
              "aria-hidden": true,
              style: {
                opacity: 0,
                pointerEvents: "none",
                userSelect: "none",
              },
            })}
          >
            {(() => {
              if (!connected) {
                return (
                <div className=" ">
                    <CtaButton
                    onClick={openConnectModal}
                    padding={"!px-20"}
                    children={"Connect Wallet"}
                  />
                </div>
                );
              }
              if (chain.unsupported) {
                return (
                  <GradientButton onClick={openChainModal} type="button">
                    Wrong network
                  </GradientButton>
                );
              }
              return (
                <div style={{ display: "flex", gap: 12 }}>
                  <CtaButton padding={"!px-20"} onClick={openAccountModal}>
                    {account.displayName}
                  </CtaButton>
                </div>
              );
            })()}
          </div>
        );
      }}
    </ConnectButton.Custom>
  );
};
